import React, { CSSProperties } from 'react';
import Accept from './Accept';
import AirConditioning from './AirConditioning';
import Bag from './Bag';
import Close from './Close';
import Fly from './Fly';
import Gallery from './Gallery';
import Gym from './Gym';
import Hotel from './Hotel';
import Lunch from './Lunch';
import Maps from './Maps';
import Maps2 from './Maps2';
import Person from './Person';
import Pool from './Pool';
import Room from './Room';
import Search from './Search';
import Suitcase from './Suitcase';
import SortDown from './SortDown';
import Bell from './Bell';
import ArrowPointToRight from './ArrowPointToRight';
import Facebook from './Facebook';
import Google from './Google';
import Drawer from './Drawer';
import Warning from './Warning';
import People from './People';
import Wireless from './Wireless';
import Cart from './Cart';
import ListenFaq from './ListenFaq';
import FolderFaq from './FolderFaq';
import Mala from './Mala';
import Charge from './Charge';
import ManyAccount from './ManyAccount';
import PaysharedAccount from './PaysharedAccount';
import PlanFlyGo from './PlanFlyGo';
import PlanHotel from './PlanHotel';
import PlanFlyBack from './PlanFlyBack';
import Washer from './Washer';
import User from './User';
import Bed from './Bed';
import FlyArriving from './FlyArriving';
import FlyGoing from './FlyGoing';
import HotelVoucher from './HotelVoucher';
import CambioCars from './Cambio';
import Mountain from './Mountain';
import CalendarAltSolid from './CalendarAltSolid';
import CalendarDaySolid from './CalendarDaySolid';
import CalendarWeekSolid from './CalendarWeekSolid';
import CitySolid from './CitySolid';
import HamburgerSolid from './HamburgerSolid';
import MusicSolid from './MusicSolid';
import RunningSolid from './RunningSolid';
import ShipSolid from './ShipSolid';
import ShoppingCartSolid from './ShoppingCartSolid';
import TreeSolid from './TreeSolid';
import UmbrellaBeachSolid from './UmbrellaBeachSolid';
import Couple from './Couple';
import Family from './Family';
import Friends from './Friends';
import Alone from './Alone';
import Spring from './Spring';
import Autumn from './Autumn';
import Winter from './Winter';
import Summer from './Summer';
import Adventure from './Adventure';
import Beach from './Beach';
import HighCity from './HighCity';
import Shopping from './Shopping';
import NightParty from './NightParty';
import CityStories from './CityStories';
import Parks from './Parks';
import FalSuitcase from './fontawesomeLightIcons/FalSuitecase';
import FalBuilding from './fontawesomeLightIcons/FalBuilding';
import FalPlane from './fontawesomeLightIcons/FalPlane';
import FalCar from './fontawesomeLightIcons/FalCar';
import FalBriefcase from './fontawesomeLightIcons/FalBriefcase';
import FalPlayCircle from './fontawesomeLightIcons/FalPlayCircle';
import FalTimesCircle from './fontawesomeLightIcons/FalTimesCircle';
import FalInfoCircle from './fontawesomeLightIcons/FalInfoCircle';
import FadEnvelope from './fontawesomeLightIcons/FadEnvelope';
import FadLock from './fontawesomeLightIcons/FadLock';
import FadTicket from './fontawesomeLightIcons/FadTicket';
import FadQuestionCircle from './fontawesomeLightIcons/FadQuestionCircle';
import FadMoneyCheckEdit from './fontawesomeLightIcons/FadMoneyCheckEdit';
import NavRight from './NavRight';
import SocialFacebook from './socialMedias/Facebook';
import SocialInstagram from './socialMedias/Instagram';
import SocialTwitter from './socialMedias/Twitter';
import SocialYoutube from './socialMedias/Youtube';
import SocialBlog from './socialMedias/Blog';
import SocialSpotify from './socialMedias/Spotify';
import LongArrowRight from './LongArrowRight';
import TicketSolid from './TicketSolid';
import CalendarStart from './CalendarStart';
import GlobeAmericas from './GlobeAmericas';
import SearchDollar from './SearchDollar';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
  name: IconName;
};

export type IconName =
  | 'accept'
  | 'airconditioning'
  | 'arrow-point-to-right'
  | 'bag'
  | 'bell'
  | 'close'
  | 'fly'
  | 'gallery'
  | 'gym'
  | 'hotel'
  | 'lunch'
  | 'maps'
  | 'maps2'
  | 'person'
  | 'pool'
  | 'room'
  | 'search'
  | 'sort-down'
  | 'suitcase'
  | 'facebook'
  | 'google'
  | 'drawer'
  | 'warning'
  | 'people'
  | 'wifi'
  | 'cart'
  | 'listen-faq'
  | 'folder-faq'
  | 'Mala'
  | 'Charge'
  | 'many-account'
  | 'pay-shared-account'
  | 'plan-fly-go'
  | 'plan-hotel'
  | 'plan-fly-back'
  | 'Washer'
  | 'fly-arriving'
  | 'fly-going'
  | 'User'
  | 'Bed'
  | 'HotelVoucher'
  | 'CambioCars'
  | 'mountain'
  | 'calendar-alt-solid'
  | 'calendar-day-solid'
  | 'calendar-week-solid'
  | 'city-solid'
  | 'hamburger-solid'
  | 'music-solid'
  | 'running-solid'
  | 'ship-solid'
  | 'shopping-cart-solid'
  | 'tree-solid'
  | 'umbrella-beach-solid'
  | 'couple'
  | 'family'
  | 'friends'
  | 'alone'
  | 'spring'
  | 'autumn'
  | 'winter'
  | 'summer'
  | 'adventure'
  | 'beach'
  | 'high-city'
  | 'shopping'
  | 'night-party'
  | 'city-stories'
  | 'parks'
  | 'falSuitcase'
  | 'falBuilding'
  | 'falPlane'
  | 'falCar'
  | 'falBriefcase'
  | 'falInfoCircle'
  | 'nav-right'
  | 'fadEnvelope'
  | 'fadLock'
  | 'fadTicket'
  | 'fadQuestionCircle'
  | 'fadMoneyCheckEdit'
  | 'socialFacebook'
  | 'socialInstagram'
  | 'socialTwitter'
  | 'socialYoutube'
  | 'socialBlog'
  | 'socialSpotify'
  | 'falPlayCircle'
  | 'falTimesCircle'
  | 'ticketSolid'
  | 'longArrowRight'
  | 'globe-americas'
  | 'calendar-star'
  | 'search-dollar';

const Icon: React.FC<Props> = props => {
  switch (props.name) {
    case 'accept':
      return <Accept {...props} />;
    case 'airconditioning':
      return <AirConditioning {...props} />;
    case 'arrow-point-to-right':
      return <ArrowPointToRight {...props} />;
    case 'bag':
      return <Bag {...props} />;
    case 'bell':
      return <Bell {...props} />;
    case 'close':
      return <Close {...props} />;
    case 'fly':
      return <Fly {...props} />;
    case 'gallery':
      return <Gallery {...props} />;
    case 'gym':
      return <Gym {...props} />;
    case 'hotel':
      return <Hotel {...props} />;
    case 'lunch':
      return <Lunch {...props} />;
    case 'maps':
      return <Maps {...props} />;
    case 'maps2':
      return <Maps2 {...props} />;
    case 'person':
      return <Person {...props} />;
    case 'pool':
      return <Pool {...props} />;
    case 'room':
      return <Room {...props} />;
    case 'search':
      return <Search {...props} />;
    case 'sort-down':
      return <SortDown {...props} />;
    case 'suitcase':
      return <Suitcase {...props} />;
    case 'facebook':
      return <Facebook {...props} />;
    case 'google':
      return <Google {...props} />;
    case 'drawer':
      return <Drawer {...props} />;
    case 'warning':
      return <Warning {...props} />;
    case 'people':
      return <People {...props} />;
    case 'wifi':
      return <Wireless {...props} />;
    case 'cart':
      return <Cart {...props} />;
    case 'listen-faq':
      return <ListenFaq {...props} />;
    case 'folder-faq':
      return <FolderFaq {...props} />;
    case 'Mala':
      return <Mala {...props} />;
    case 'Charge':
      return <Charge {...props} />;
    case 'many-account':
      return <ManyAccount {...props} />;
    case 'pay-shared-account':
      return <PaysharedAccount {...props} />;
    case 'plan-fly-go':
      return <PlanFlyGo {...props} />;
    case 'plan-hotel':
      return <PlanHotel {...props} />;
    case 'plan-fly-back':
      return <PlanFlyBack {...props} />;
    case 'Washer':
      return <Washer {...props} />;
    case 'fly-arriving':
      return <FlyArriving {...props} />;
    case 'fly-going':
      return <FlyGoing {...props} />;
    case 'User':
      return <User {...props} />;
    case 'Bed':
      return <Bed {...props} />;
    case 'HotelVoucher':
      return <HotelVoucher {...props} />;
    case 'CambioCars':
      return <CambioCars {...props} />;
    case 'mountain':
      return <Mountain {...props} />;
    case 'calendar-alt-solid':
      return <CalendarAltSolid {...props} />;
    case 'calendar-day-solid':
      return <CalendarDaySolid {...props} />;
    case 'calendar-week-solid':
      return <CalendarWeekSolid {...props} />;
    case 'city-solid':
      return <CitySolid {...props} />;
    case 'hamburger-solid':
      return <HamburgerSolid {...props} />;
    case 'music-solid':
      return <MusicSolid {...props} />;
    case 'running-solid':
      return <RunningSolid {...props} />;
    case 'ship-solid':
      return <ShipSolid {...props} />;
    case 'shopping-cart-solid':
      return <ShoppingCartSolid {...props} />;
    case 'tree-solid':
      return <TreeSolid {...props} />;
    case 'umbrella-beach-solid':
      return <UmbrellaBeachSolid {...props} />;
    case 'couple':
      return <Couple {...props} />;
    case 'family':
      return <Family {...props} />;
    case 'friends':
      return <Friends {...props} />;
    case 'alone':
      return <Alone {...props} />;
    case 'spring':
      return <Spring {...props} />;
    case 'autumn':
      return <Autumn {...props} />;
    case 'winter':
      return <Winter {...props} />;
    case 'summer':
      return <Summer {...props} />;
    case 'adventure':
      return <Adventure {...props} />;
    case 'beach':
      return <Beach {...props} />;
    case 'high-city':
      return <HighCity {...props} />;
    case 'shopping':
      return <Shopping {...props} />;
    case 'night-party':
      return <NightParty {...props} />;
    case 'city-stories':
      return <CityStories {...props} />;
    case 'parks':
      return <Parks {...props} />;
    case 'falSuitcase':
      return <FalSuitcase {...props} />;
    case 'falBuilding':
      return <FalBuilding {...props} />;
    case 'falPlane':
      return <FalPlane {...props} />;
    case 'falCar':
      return <FalCar {...props} />;
    case 'falBriefcase':
      return <FalBriefcase {...props} />;
    case 'falInfoCircle':
      return <FalInfoCircle {...props} />;
    case 'nav-right':
      return <NavRight {...props} />;
    case 'fadEnvelope':
      return <FadEnvelope {...props} />;
    case 'fadLock':
      return <FadLock {...props} />;
    case 'fadTicket':
      return <FadTicket {...props} />;
    case 'fadQuestionCircle':
      return <FadQuestionCircle {...props} />;
    case 'fadMoneyCheckEdit':
      return <FadMoneyCheckEdit {...props} />;
    case 'socialFacebook':
      return <SocialFacebook {...props} />;
    case 'socialInstagram':
      return <SocialInstagram {...props} />;
    case 'socialTwitter':
      return <SocialTwitter {...props} />;
    case 'socialYoutube':
      return <SocialYoutube {...props} />;
    case 'socialBlog':
      return <SocialBlog {...props} />;
    case 'socialSpotify':
      return <SocialSpotify {...props} />;
    case 'falPlayCircle':
      return <FalPlayCircle {...props} />;
    case 'falTimesCircle':
      return <FalTimesCircle {...props} />;
    case 'longArrowRight':
      return <LongArrowRight {...props} />;
    case 'ticketSolid':
      return <TicketSolid {...props} />;
    case 'calendar-star':
      return <CalendarStart {...props} />;
    case 'globe-americas':
      return <GlobeAmericas {...props} />;
    case 'search-dollar':
      return <SearchDollar {...props} />;
    default:
      return null;
  }
};

export default Icon;
